import { render, staticRenderFns } from "./CompanyDetailsGeneralData.vue?vue&type=template&id=b72e217e&"
import script from "./CompanyDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports